import { render, staticRenderFns } from "./UserFormInsurance.vue?vue&type=template&id=6adb545b&scoped=true&"
import script from "./UserFormInsurance.vue?vue&type=script&lang=js&"
export * from "./UserFormInsurance.vue?vue&type=script&lang=js&"
import style0 from "./UserFormInsurance.vue?vue&type=style&index=0&id=6adb545b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adb545b",
  null
  
)

export default component.exports